module.exports = window.__loadPromiseRequirejs__("mediaFrame");